'use strict';

let instanceCount = 0;

const saOnClickOutside = [
  '$window',
  '$timeout',

  function ($window, $timeout) {
    return {
      scope: {
        saOnClickOutside: '&'
      },
      link: function ($scope, $element) {
        var documentEl = angular.element($window.document);
        var body = $window.document.body;
        var wasClickedInside = false;
        var index = instanceCount++;

        function documentClickHandler(event) {
          if (!wasClickedInside && index === instanceCount - 1 && event.target !== body) {
            $scope.$apply(function () {
              $scope.saOnClickOutside();
            });
          }

          wasClickedInside = false;
        }

        $element.on('click', function () {
          wasClickedInside = true;
        });

        $timeout(function () {
          documentEl.on('click', documentClickHandler);
        });

        $element.on('$destroy', function () {
          documentEl.off('click', documentClickHandler);
          --instanceCount;
        });
      }
    };
  }
];

export default saOnClickOutside;



// WEBPACK FOOTER //
// ./app/src/directives/on_click_outside.js